// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/leads/:id\",\"regex\":\"^/leads/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/questions/:id\",\"regex\":\"^/questions/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:locale/lang-test\",\"regex\":\"^/([^/]+)/lang-test$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[{\"path\":\"/select-exhibitor\"},{\"path\":\"/\"},{\"path\":\"/500\"},{\"path\":\"/home\"},{\"path\":\"/leads\"},{\"path\":\"/products\"},{\"path\":\"/questions\"},{\"path\":\"/questions/new\"},{\"path\":\"/reports\"},{\"path\":\"/change-password\"},{\"path\":\"/login\"},{\"path\":\"/mfa\"},{\"path\":\"/request-magic-link\"},{\"path\":\"/request-magic-link/success\"},{\"path\":\"/request-password-reset\"},{\"path\":\"/request-password-reset/success\"},{\"path\":\"/web-login-magic-link\"},{\"path\":\"/figma-test\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.4";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';

// Only initialize Sentry on the client side
if (globalThis.window !== undefined) {
  Sentry.init({
    dsn: 'https://ce175a2bebcef539fdeb797cc1197294@o4510505050767360.ingest.de.sentry.io/4510561997160528',

    // Enable debug mode to see detailed Sentry logs in console
    // Set to false in production to reduce console noise
    debug: false,

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    // 1.0 = 100% of transactions will be sent to Sentry
    tracesSampleRate: 1,

    // Enable logs to be sent to Sentry
    enableLogs: true,

    // Enable sending user PII (Personally Identifiable Information)
    // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    // Add screen resolution and user info to all events
    beforeSend(event, hint) {
      if (globalThis.window !== undefined) {
        // Add screen resolution as context
        event.contexts = {
          ...event.contexts,
          screen: {
            width: globalThis.window.screen.width,
            height: globalThis.window.screen.height,
            availWidth: globalThis.window.screen.availWidth,
            availHeight: globalThis.window.screen.availHeight,
            colorDepth: globalThis.window.screen.colorDepth,
            pixelDepth: globalThis.window.screen.pixelDepth,
          },
          // Also add viewport size
          viewport: {
            width: globalThis.window.innerWidth,
            height: globalThis.window.innerHeight,
          },
        };

        // Also add as tags for easier filtering in Sentry UI
        event.tags = {
          ...event.tags,
          screenResolution: `${globalThis.window.screen.width}x${globalThis.window.screen.height}`,
          viewportSize: `${globalThis.window.innerWidth}x${globalThis.window.innerHeight}`,
        };

        // User info will be set via setSentryUser() called from login components
        // The user will be automatically included from Sentry.getCurrentScope().getUser()
      }
      return event;
    },
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
